import { supabase } from './supabase';

const GUEST_KEY = 'bitelearning_saved';

// ── Get all saved items ───────────────────────────────────────────────────────
export async function getSavedItems({ userId, isGuest }) {
  if (isGuest || !userId) {
    return { data: _guestRead(), error: null };
  }
  return await supabase
    .from('saved_content')
    .select('*')
    .eq('user_id', userId)
    .order('saved_at', { ascending: false });
}

// ── Save an item ──────────────────────────────────────────────────────────────
export async function saveItem({ userId, isGuest, item }) {
  if (isGuest || !userId) {
    const saved = _guestRead().filter(i => i.item_id !== item.item_id);
    saved.unshift({ ...item, id: `guest_${Date.now()}`, saved_at: new Date().toISOString() });
    _guestWrite(saved);
    return { data: item, error: null };
  }
  const { data, error } = await supabase
    .from('saved_content')
    .upsert({ ...item, user_id: userId }, { onConflict: 'user_id,item_id' })
    .select()
    .single();
  return { data, error };
}

// ── Unsave an item ────────────────────────────────────────────────────────────
export async function unsaveItem({ userId, isGuest, itemId }) {
  if (isGuest || !userId) {
    _guestWrite(_guestRead().filter(i => i.item_id !== itemId));
    return { error: null };
  }
  return await supabase
    .from('saved_content')
    .delete()
    .eq('user_id', userId)
    .eq('item_id', itemId);
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function _guestRead() {
  try { return JSON.parse(localStorage.getItem(GUEST_KEY) || '[]'); }
  catch { return []; }
}
function _guestWrite(arr) {
  try { localStorage.setItem(GUEST_KEY, JSON.stringify(arr)); } catch {}
}

// ── Build item objects from different content types ───────────────────────────
export function buildTextSaveItem(lesson, subject) {
  return {
    content_type: 'text',
    item_id:      `text::${subject}::${lesson.aiModel}`,
    subject,
    title:        lesson.title,
    url:          null,
    thumbnail:    null,
    content_data: lesson,
  };
}

export function buildVideoSaveItem(video, subject) {
  return {
    content_type: 'video',
    item_id:      `video::${video.id}`,
    subject,
    title:        video.title,
    url:          video.url,
    thumbnail:    video.thumbnail || null,
    content_data: { channel: video.channel, duration: video.duration },
  };
}

export function buildAudioSaveItem(podcast, subject) {
  return {
    content_type: 'audio',
    item_id:      `audio::${podcast.url}`,
    subject,
    title:        podcast.title,
    url:          podcast.url,
    thumbnail:    podcast.thumbnail || null,
    content_data: { channel: podcast.channel, duration: podcast.duration },
  };
}
